import { ApplicationConfig, LOCALE_ID, importProvidersFrom } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { routes } from './routes';
import { environment } from 'src/environments/environment';
import { provideClientHydration, withNoHttpTransferCache } from '@angular/platform-browser';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { scrollConfig } from './scroll-config';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(
            routes,
            withInMemoryScrolling(scrollConfig),
        ),
        importProvidersFrom([
            BrowserAnimationsModule,
        ]),
        {
            provide: LOCALE_ID,
            useValue: environment.locale.id
        },
        provideClientHydration(withNoHttpTransferCache()),
        provideHttpClient(withFetch())
    ]
};
